<script lang="ts">
	import { Text } from '$lib/components/ui/text';
	import { t } from '$lib/i18n';
	import Header from './header/Header.svelte';

	const partnersImg = ['spic', 'eic', 'bnb chain', 'pancake', 'telegram'];
</script>

<div class="bg-with-opacity flex min-h-screen w-full flex-col">
	<div class="container mx-auto px-4">
		<div class="mb-[80px] flex flex-col gap-5 pt-[100px] md:mb-[150px]">
			<Header title={$t('landing.incubator')}></Header>
			<div class="flex justify-center">
				<img src="/img/landing/incubator/eic labs.png" alt="eic labs" />
			</div>
		</div>

		<div class="flex flex-col items-center gap-[30px]">
			<Text size="3xl" class="pixel-font text-center">{$t('landing.ecosystem_partner')}</Text>
			<div class="grid gap-[40px] xl:grid-cols-3">
				{#each partnersImg as img}
					<div
						class="flex h-[100px] items-center justify-center rounded-md bg-[#3C3A61]/60 px-5 md:w-[400px]"
					>
						<img
							src="/img/landing/incubator/partners/{img}.{img === 'telegram' ? 'svg' : 'png'}"
							alt="partners_img"
							class="md:h-[60px] {img === 'telegram' ? ' w-12' : ''}"
						/>
						{#if img === 'telegram'}
							<p class="ml-2 text-3xl font-bold">Telegram</p>
						{/if}
					</div>
				{/each}
			</div>
		</div>
	</div>
</div>

<style>
	.bg-with-opacity {
		position: relative;
		width: 100%;
		min-height: 1000px;
	}

	.bg-with-opacity::before {
		content: '';
		background-image: url('/img/landing/incubator/background.png');
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		opacity: 0.3;
		z-index: -2;
	}

	.bg-with-opacity::after {
		content: '';
		background: linear-gradient(
			360deg,
			#110f27 5%,
			rgba(17, 15, 39, 0) 12%,
			rgba(17, 15, 39, 0) 87.5%,
			#110f27 100%
		);
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: -1;
	}
</style>
